"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _memoWithDisplayName = _interopRequireDefault(require("../utils/memoWithDisplayName"));

var _validHref = _interopRequireDefault(require("../utils/propTypes/validHref"));

var _ThrowError = require("../utils/ThrowError");

var _UnsafeUrl = require("../utils/UnsafeUrl");

var SHAPE_CLASSES = {
  default: '',
  circle: 'img-circle private-image--circle',
  rounded: 'img-rounded private-image--rounded',
  thumbnail: 'img-thumbnail private-image--thumbnail'
};
var OBJECT_FIT_CLASSES = {
  fill: '',
  contain: 'private-image--object-fit-contain'
};
var UIImage = (0, _memoWithDisplayName.default)('UIImage', (0, _react.forwardRef)(function (props, ref) {
  var bordered = props.bordered,
      className = props.className,
      objectFit = props.objectFit,
      onError = props.onError,
      onLoad = props.onLoad,
      responsive = props.responsive,
      shape = props.shape,
      src = props.src,
      style = props.style,
      rest = (0, _objectWithoutProperties2.default)(props, ["bordered", "className", "objectFit", "onError", "onLoad", "responsive", "shape", "src", "style"]);

  if ((0, _UnsafeUrl.isUnsafeUrl)(src)) {
    (0, _ThrowError.throwErrorAsync)(new Error("UIImage: Detected XSS attempt! src=\"" + src + "\""));
  }

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loadFailed = _useState2[0],
      setLoadFailed = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      styleOverrides = _useState4[0],
      setStyleOverrides = _useState4[1];
  /** A ref to the <img> element */


  var imgRef = (0, _react.useRef)(null);
  var img = imgRef.current;
  var needsPolyfill = !('objectFit' in document.documentElement.style || objectFit !== 'contain');

  var polyfillObjectFit = function polyfillObjectFit() {
    // If style overrides already exist, do nothing
    if (styleOverrides && Object.keys(styleOverrides).length !== 0) return; // Compute the natural image ratio

    var naturalWidth = img.naturalWidth,
        naturalHeight = img.naturalHeight;
    if (!naturalWidth || !naturalHeight) return;
    var imgAspectRatio = naturalWidth / naturalHeight;
    var renderedWidth = img.clientWidth;
    var renderedHeight = img.clientHeight;
    var fittedHeight = renderedWidth / imgAspectRatio;
    var fittedWidth = renderedHeight * imgAspectRatio;

    if (renderedHeight > fittedHeight) {
      setStyleOverrides({
        height: fittedHeight
      });
    } else if (renderedWidth > fittedWidth) {
      setStyleOverrides({
        width: fittedWidth
      });
    }
  };
  /** Re-render without any style overrides, then recompute style overrides */


  var resetOverrides = function resetOverrides() {
    setStyleOverrides({});
  };

  (0, _react.useLayoutEffect)(function () {
    if (!needsPolyfill || !img) return undefined;
    polyfillObjectFit();
    addEventListener('resize', resetOverrides);
    return function () {
      removeEventListener('resize', resetOverrides);
    };
  });

  var handleImageError = function handleImageError(evt) {
    if (onError) onError(evt);
    setLoadFailed(true);
  };

  var handleImageLoad = function handleImageLoad(evt) {
    if (onLoad) onLoad(evt);
    imgRef.current = evt.target;
    setLoadFailed(false);
    if (needsPolyfill) resetOverrides();
  };
  /* eslint-disable jsx-a11y/alt-text */


  return _react.default.createElement("img", (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-image', SHAPE_CLASSES[shape], OBJECT_FIT_CLASSES[objectFit], className, {
      'img-responsive private-image--responsive': responsive,
      'image-load-failed': loadFailed,
      'private-image--bordered': bordered
    }),
    onError: handleImageError,
    onLoad: handleImageLoad,
    ref: ref,
    src: (0, _UnsafeUrl.isUnsafeUrl)(src) ? null : src,
    style: (0, _extends2.default)({}, style, styleOverrides)
  }));
  /* eslint-enable jsx-a11y/alt-text */
}));
UIImage.propTypes = {
  alt: _propTypes.default.string.isRequired,
  bordered: _propTypes.default.bool.isRequired,
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  onError: _propTypes.default.func,
  onLoad: _propTypes.default.func,
  objectFit: _propTypes.default.oneOf(Object.keys(OBJECT_FIT_CLASSES)).isRequired,
  responsive: _propTypes.default.bool.isRequired,
  shape: _propTypes.default.oneOf(Object.keys(SHAPE_CLASSES)).isRequired,
  src: _validHref.default.isRequired,
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
UIImage.defaultProps = {
  alt: '',
  bordered: false,
  objectFit: 'fill',
  responsive: true,
  shape: 'default'
};
var _default = UIImage;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3773/js/image/UIImage.js
// module id = 178
// module chunks = 0